/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ColumnTypeNumber({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M5.438.938v14.124h-1V.938h1ZM11.563.938v14.124h-1V.938h1Z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M.938 4.438h14.124v1H.938v-1ZM.938 10.563h14.124v1H.938v-1Z" clipRule="evenodd" /></svg>;
}
;